var React = require('react');

function ArrowSmFgreenUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.000363499 6.0235C-0.0101025 6.39657 0.205829 6.75725 0.576194 6.91786L0.578919 6.91904C0.957774 7.08053 1.38985 6.98595 1.66403 6.70254L5.99878 2.30867L10.3323 6.70128C10.5711 6.95151 10.9363 7.06002 11.2867 6.96729C11.6342 6.87479 11.8874 6.6059 11.9703 6.28582C12.0522 5.96764 11.9621 5.62243 11.7176 5.38275L6.69146 0.288024C6.3126 -0.0960075 5.68496 -0.0960075 5.30609 0.288024L0.278311 5.38439C0.105534 5.55681 0.00740756 5.78609 0.000363499 6.0235Z","fill":"#003B1B"}));
}

ArrowSmFgreenUp.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = ArrowSmFgreenUp;

ArrowSmFgreenUp.default = ArrowSmFgreenUp;
